export function splitArray<T extends Array<unknown>, U extends (value: T[number], index: number, array: T) => boolean>(
  a: T,
  b: U
) {
  const match = [] as unknown as T;
  const unmatch = [] as unknown as T;
  a.forEach((v, i) => {
    if (b(v, i, a)) {
      match.push(v);
    } else {
      unmatch.push(v);
    }
  });
  return [match, unmatch] as [match: T, unmatch: T];
}
